import { h } from 'preact'
import { attributesAnalytics } from '../../js/modules/component'

export const ReassuranceBoutique = ({ title, items, cacheKey }) => {
   return (
      <div class="container-fluid">
         <div data-testid="bande-reassurance-boutique" class="row mt-md-4 reassurance-boutique" data-cache-key={cacheKey}>
            <div class="col-12">
               <h2>{title}</h2>
            </div>
            <div class="col-12">
               <ul class="row mb-0 list-unstyled">
                  {items.map((item, index) => (
                     <li
                        class="col-12 col-md-4 mb-2 d-flex lien-composite-before"
                        data-testid={`reassurance-boutique${index + 1}`}
                        {...attributesAnalytics(item.CTA.analytics)}
                     >
                        <div class="img-icon">
                           <img loading="lazy" src={item.image} alt="" width="40" />
                        </div>
                        <div class="d-flex flex-column item flex-1">
                           <h3 class="title mb-0 w-md-75" dangerouslySetInnerHTML={{ __html: addSup(item.title) }}></h3>
                           <p class="w-md-75 mb-0 mb-md-1">{item.description}</p>
                           <a href={item.CTA.URL} class="mt-auto mw-100 link o-link-arrow" target={item.CTA.target}>
                              <strong class="mw-100">{item.CTA.label}</strong>
                           </a>
                        </div>
                     </li>
                  ))}
               </ul>
            </div>
         </div>
      </div>
   )
}

const addSup = (text) => {
   return text.replace('(1)', '<sup>(1)</sup>')
}
